export default "__VITE_ASSET__f4b15462__"